module.exports = __webpack_public_path__ + "media/images/errors/404-graphic@2x-c30fd2a5b7b74e9ce352567b5240e11d.png";